var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5218Close(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01462 22.5719C7.62409 22.9625 7.62409 23.5956 8.01462 23.9862C8.40514 24.3767 9.03831 24.3767 9.42883 23.9862L16.0008 17.4142L22.5727 23.9862C22.9632 24.3767 23.5964 24.3767 23.9869 23.9862C24.3774 23.5956 24.3774 22.9625 23.9869 22.5719L17.415 16L23.9869 9.42805C24.3775 9.03753 24.3775 8.40436 23.9869 8.01384C23.5964 7.62332 22.9632 7.62332 22.5727 8.01384L16.0008 14.5858L9.42879 8.01384C9.03826 7.62332 8.4051 7.62332 8.01457 8.01384C7.62405 8.40437 7.62405 9.03753 8.01457 9.42806L14.5865 16L8.01462 22.5719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5218Close);
export default __webpack_public_path__ + "static/media/5218_close.245fd9a3831bb7f00852845f7d8c9ba1.svg";
export { ForwardRef as ReactComponent };